/**
 * FikoKesim — Lazer/Plazma/Su Jeti kesim süresi & maliyeti motoru
 * Çevre uzunluğu × kesim hızı + delme süresi → süre → işçilik + gaz/sarf maliyeti.
 */

export type KesimProses = 'lazer' | 'plazma' | 'sujeti';

/** Proses varsayılan kesim hızı (mm/dk, ~orta kalınlık) + delme süresi (sn) + ek gaz ₺/dk. */
export const KESIM_PROSES: Record<KesimProses, { ad: string; hiz: number; delme: number; gazDk: number }> = {
  lazer:  { ad: 'Lazer',   hiz: 3000, delme: 0.8, gazDk: 4 },
  plazma: { ad: 'Plazma',  hiz: 2000, delme: 0.5, gazDk: 2 },
  sujeti: { ad: 'Su Jeti', hiz: 300,  delme: 3.0, gazDk: 8 },
};

export interface KesimGirdi {
  cevreUzunlukMm: number;   // toplam kesim yolu (dış kontur + delikler)
  delmeSayisi: number;      // pierce sayısı
  kesimHizMmDk: number;     // mm/dk
  delmeSureSn: number;      // pierce başına sn
  saatUcreti: number;       // tezgâh ₺/saat
  gazUcretDk: number;       // gaz/sarf ₺/dk
  adet: number;
}

export interface KesimSonuc {
  kesimSureDk: number; delmeSureDk: number; toplamSureDk: number;
  isciMaliyet: number; gazMaliyet: number; birimMaliyet: number; toplamMaliyet: number;
}

export function kesimHesapla(g: KesimGirdi): KesimSonuc {
  const adet = Math.max(1, g.adet || 1);
  const kesimSureDk = g.kesimHizMmDk > 0 ? g.cevreUzunlukMm / g.kesimHizMmDk : 0;
  const delmeSureDk = (g.delmeSayisi * g.delmeSureSn) / 60;
  const toplamSureDk = kesimSureDk + delmeSureDk;
  const isciMaliyet = (toplamSureDk / 60) * g.saatUcreti;
  const gazMaliyet = toplamSureDk * (g.gazUcretDk || 0);
  const birimMaliyet = isciMaliyet + gazMaliyet;
  return {
    kesimSureDk, delmeSureDk, toplamSureDk,
    isciMaliyet, gazMaliyet, birimMaliyet, toplamMaliyet: birimMaliyet * adet,
  };
}
